export default {
    namespaced: true,
    state:{
        params:{},
        publicParams:{}
    },
    getters:{},
    mutations: {
        setParams(state,params){
            state.params = params
            // console.log(params)
        },
        setPublic(state,params){
            state.publicParams = params
            // console.log(params,33333)
        }
    },

}